import {
    ListLayoutConfig,
    ListLayoutViewType,
    TableConfig,
    KanbanConfig,
    TimelineConfig,
    CalendarConfig,
} from './list-layout.types';

export function createDefaultListLayoutConfig(storageKey: string): ListLayoutConfig {
    return {
        enabledViews: [
            ListLayoutViewType.Table,
            ListLayoutViewType.Kanban,
            ListLayoutViewType.Timeline,
            ListLayoutViewType.Calendar,
        ],
        defaultView: ListLayoutViewType.Table,
        enableFilters: true,
        enableExports: true,
        enableSavedFilters: true,
        storageKey,
    };
}

export function createDefaultTableConfig(): TableConfig {
    return {
        columns: [],
        serverSidePagination: true,
        pageSize: 50,
        pageSizeOptions: [10, 25, 50, 100],
        sortable: true,
        selectable: false,
    };
}

export function createDefaultKanbanConfig(groupByProperty: string): KanbanConfig {
    return {
        groupByProperty,
        columns: [],
        enableDragDrop: true,
        cardHeight: 120,
        swimlanes: false,
    };
}

export function createDefaultTimelineConfig(
    startDateProperty: string,
    endDateProperty: string
): TimelineConfig {
    return {
        startDateProperty,
        endDateProperty,
        rowHeight: 40,
        segmentTypes: [],
        enableZoom: true,
        minZoom: 0.5,
        maxZoom: 3,
    };
}

export function createDefaultCalendarConfig(dateProperty: string, titleProperty: string): CalendarConfig {
    return {
        dateProperty,
        titleProperty,
        viewMode: 'month',
        enableDragDrop: false,
        weekStartsOn: 1,
    };
}

export function mergeConfig<T>(defaultConfig: T, userConfig: Partial<T> | undefined): T {
    if (!userConfig) {
        return defaultConfig;
    }
    return {
        ...defaultConfig,
        ...userConfig,
    };
}
